import { useEffect } from 'react';
export function useFundingFunnel(client, observation, enabled = true) {
    const { stage, outcome, method, operationId, errorCode } = observation;
    useEffect(() => {
        if (!enabled)
            return;
        client.observeFunnel?.({
            stage,
            outcome,
            method: method ?? null,
            operationId: operationId ?? null,
            errorCode: errorCode ?? null,
        });
    }, [client, stage, outcome, method, operationId, errorCode, enabled]);
}
